// extracted by mini-css-extract-plugin
export var card = "EventCard-module--card--1_hFe";
export var horizontal = "EventCard-module--horizontal--3zwsD";